
import { Button, Col, Modal, Row, Space, Table } from 'antd'
import styles from './index.module.less';
import { useRequest } from 'ahooks'
import { deleteContactInfo, getContactInfoList } from '@/services/site/contact-info.service'
import { useState } from 'react'

const companySizeMap = {
  '30': '1 - 30',
  '100': '31 - 100',
  '400': '101 - 400',
  '1000': '401 - 1,000',
  '1001': '1,000+'
}

export const ContactInfoList = () => {
  const {data, run} = useRequest(getContactInfoList)
  const [record, setRecord] = useState<any>(null)

  const onDelete = async (record) => {
    await deleteContactInfo(record.id)
    run()
  }

  const columns = [
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: 'Company Size',
      render: (_, record) => {
        return companySizeMap[record?.companySize] || '-'
      }
    },
    {
      title: 'Actions',
      render: (_, curRecord) => {
        return <Space>
          <Button type='link' size='small' onClick={() => setRecord(curRecord)}>Show</Button>
          <Button type='link' danger size='small' onClick={() => onDelete(curRecord)}>Delete</Button>
        </Space>
      }
    }
  ]

  return <div className={styles.container}>
    <Table columns={columns} dataSource={data} size="small" bordered/>
    <Modal
      title='Contact Info'
      width={800}
      open={!!record}
      onCancel={() => setRecord(null)}
      footer={null}
    >
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Email:</Col>
        <Col>{record?.email}</Col>
      </Row>
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Name:</Col>
        <Col>{record?.firstName} {record?.lastName}</Col>
      </Row>
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Phone:</Col>
        <Col>{record?.phone}</Col>
      </Row>
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Company:</Col>
        <Col>{record?.company}</Col>
      </Row>
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Company Size:</Col>
        <Col>{companySizeMap[record?.companySize] || '-'}</Col>
      </Row>
      <Row gutter={10}>
        <Col span={5} style={{textAlign: 'right'}}>Message:</Col>
        <Col>{record?.message}</Col>
      </Row>
      
    </Modal>
  </div>
}